import React, { useEffect } from 'react';
import { getBrandName } from '../utils/brand';

// `e` wraps an endpoint path in <code> for inline display.
const e = path => <code>{path}</code>;

const entries = [
    {
        date: '2026-04-30',
        version: '1.4',
        items: [
            <>New canonical flat URLs: {e('POST /checklists')}, {e('POST /tasks')}, {e('POST /comments')}, {e('POST /tokens')}.</>,
            <>New endpoints: {e('PATCH /cards/:id')}, {e('GET /cards/:id/tokens')}, {e('DELETE /tokens/:id')}, {e('GET /boards/:publicId')}.</>,
            <>Full checklist + task lifecycle now exposed externally (update, delete, move).</>,
            <>Old paths ({e('POST /cards/:id/checklists')}, {e('/cards/:id/comments')}, {e('/cards/:id/tokens')}, {e('PUT /cards/:id')}, {e('/board/...')}) marked deprecated. They still work — please migrate.</>,
            <>Downloadable Postman collection added under Tools.</>,
        ],
    },
    {
        date: '2024-09-12',
        version: '1.3',
        items: [
            <>Added {e('/board/:publicId/reports/:reportType')} for board-level analytics.</>,
            <>Added {e('/cards/:id/metrics')} for per-card cycle time data.</>,
        ],
    },
    {
        date: '2023-04-04',
        version: '1.2',
        items: [
            <>Webhooks management endpoints (CRUD).</>,
            <>Card history endpoint added.</>,
        ],
    },
];

const Changelog = () => {
    const brandName = getBrandName();
    useEffect(() => {
        document.title = `Changelog · ${brandName} Docs`;
    }, [brandName]);

    return (
        <div className="swagger-ui doc-page">
            <div className="information-container wrapper">
                <div className="info">
                    <h2 className="title">Changelog</h2>
                    <p>
                        Notable additions to the {brandName} public API. We follow{' '}
                        <a
                            className="link"
                            rel="noopener noreferrer"
                            target="_blank"
                            href="https://semver.org/"
                        >
                            semantic versioning
                        </a>{' '}
                        — breaking changes bump the major version and are announced in advance.
                    </p>

                    {entries.map(entry => (
                        <section key={entry.version} className="changelog-entry">
                            <header>
                                <h2>
                                    <span className="changelog-version">v{entry.version}</span>
                                    <time dateTime={entry.date} className="changelog-date">
                                        {new Date(entry.date).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric',
                                        })}
                                    </time>
                                </h2>
                            </header>
                            <ul className="circle">
                                {entry.items.map((item, idx) => (
                                    <li key={idx}>{item}</li>
                                ))}
                            </ul>
                        </section>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Changelog;
